import type { CountyAdapter, ParsedDocument } from "../types";

const parse = (text: string): ParsedDocument[] => {
  const lines = text
    .split("\n")
    .map((l) => l.trim())
    .filter((l) => l);
  const out: ParsedDocument[] = [];
  let i = 0;
  while (i < lines.length) {
    if (/^\d{1,3}$/.test(lines[i])) {
      i++;
      continue;
    }
    if (!/^\d{12}$/.test(lines[i])) {
      i++;
      continue;
    }
    const documentNumber = lines[i++];
    while (i < lines.length && /^\d{1,5}$/.test(lines[i])) i++;
    const documentType = lines[i++] || "";

    let grantor = "";
    let grantee = "";
    let filingDate = "";

    if (lines[i] === "R") {
      i++;
      const arr: string[] = [];
      while (
        i < lines.length &&
        lines[i] !== "E" &&
        !/^\d{2}\/\d{2}\/\d{4}$/.test(lines[i])
      ) {
        arr.push(lines[i++]);
      }
      grantor = arr.join(" ");
    }
    if (lines[i] === "E") {
      i++;
      const arr: string[] = [];
      while (i < lines.length && !/^\d{2}\/\d{2}\/\d{4}$/.test(lines[i])) {
        arr.push(lines[i++]);
      }
      grantee = arr.join(" ");
    }
    if (i < lines.length && /^\d{2}\/\d{2}\/\d{4}$/.test(lines[i])) {
      filingDate = lines[i++];
    }
    const propLines: string[] = [];
    while (
      i < lines.length &&
      lines[i] !== "View" &&
      !/^\d{12}$/.test(lines[i]) &&
      !/^\d{1,3}$/.test(lines[i])
    ) {
      propLines.push(lines[i++]);
    }
    if (i < lines.length && lines[i] === "View") i++;

    if (!documentType.toUpperCase().includes("LAND CONTRACT")) continue;

    const property = propLines.join(" | ");
    const [m, d, y] = filingDate.split("/");
    const isoDate = y
      ? `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`
      : new Date().toISOString().split("T")[0];

    out.push({
      documentNumber,
      documentType,
      filingDate: isoDate,
      grantors: grantor ? [grantor] : [],
      grantees: grantee ? [grantee] : [],
      legalDescription: property || undefined,
      propertyAddress: property || undefined,
    });
  }
  return out;
};

export const champaignAdapter: CountyAdapter = {
  countyId: "champaign",
  countyLabel: "Champaign County, OH - Land Contract Parser",
  description:
    "Paste Champaign County recorder search results. Parses R/E grantor/grantee blocks and 12-digit document numbers.",
  placeholder: "Paste the full Champaign County text output here...",
  detectionReasons: ["Champaign County OH", "Land Contract"],
  confidenceScore: 95,
  parse,
};
